angular.module('eStories.freemium', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.freemium', {
                url: 'startnow',
                views: {
                    'mainView@': {
                        templateUrl: 'home/freemium/freemium.tmpl.html',
                        controller: 'FreemiumCtrl as freemiumCtrl'
                    }
                }
            })
            .state('eStories.navbars.redeemGift', {
                url: 'redeemGift?token',
                views: {
                    'mainView@': {
                        templateUrl: 'home/freemium/freemium.tmpl.html',
                        controller: 'FreemiumCtrl as freemiumCtrl'
                    }
                }
            });
    }])

    .controller('FreemiumCtrl', [
        'CatalogModel',
        'BillingModel',
        'GiftModel',
        '$rootScope',
        '$stateParams',
        '$state',
        'AccountModel',
        'PagingModel',
        '$scope',
        'GA',
        '$location',
        'SeoModel',

        function (CatalogModel, BillingModel, GiftModel, $rootScope, $stateParams, $state, AccountModel, PagingModel,
                  $scope, GA, $location, SeoModel) {

            var freemiumCtrl = this;

            GA.trackPageView($location.path());

            if (AccountModel.isUserLoggedIn != null) {
                $state.go('eStories.navbars.home');
            }

            freemiumCtrl.signUpOrConfirmTrial = function () {
                AccountModel.signUpOrConfirmTrial();

            };

            var giftToken = $stateParams.token;
            if (giftToken != null) {
                GiftModel.setGiftToken(giftToken);
                if (AccountModel.isUserLoggedIn != null) {
                    AccountModel.openGiftRedemptionModal();
                } else {
//                    $state.go('eStories.navbars.home');
                    AccountModel.openGiftRedemptionModal();
                }
            }

            $rootScope.titleContentValue = 'eStories | ' + SeoModel.catalogCount + ' Free Audiobooks | eStories.com';
            $rootScope.titleValue = 'eStories | ' + SeoModel.freeCatalogCount + ' Free Audiobooks';

            freemiumCtrl.setShowSectionType = function (sectionName) {
                freemiumCtrl.showSectionType = sectionName;
            };

            freemiumCtrl.showSectionType = "FREE_BOOKS_FREEMIUM";

            freemiumCtrl.shouldShowSection = function (sectionName) {
                if (!sectionName) {
                    return;
                }
                if (sectionName == freemiumCtrl.showSectionType) {
                    return true;
                } else {
                    return false;
                }

            };

            freemiumCtrl.getFreeBooksSection = async function () {
                const response = await CatalogModel.getSectionList(["LANDING_SECTIONS", 'FREEMIUM_LANDING_PAGE']);
                var sectionList = response.sectionList;
                freemiumCtrl.landingSectionsMap = {};
                freemiumCtrl.landingSectionItemListMap = {};
                for (var i = 0; i < sectionList.length; i++) {
                    var section = sectionList[i];
                    var sectionContext = 'LANDING_SECTIONS';
                    if (freemiumCtrl.landingSectionsMap[sectionContext] == null) {
                        freemiumCtrl.landingSectionsMap[sectionContext] = [];
                    }
                    freemiumCtrl.landingSectionsMap[sectionContext].push(section);

                    if (section.sectionType == 'GRID') {
                        freemiumCtrl.getSectionItemList(section.id, 1, 12, function (section, response) {
                            freemiumCtrl.landingSectionItemListMap[section.id] = response.sectionItemList;
                            safeApply($scope);
                        }.bind(this, section));
                    }
                }

                freemiumCtrl.landingSectionsMap[sectionContext].push(freemiumCtrl.fullCap);

                CatalogModel.landingSectionsMap = freemiumCtrl.landingSectionsMap;
                CatalogModel.landingSectionItemListMap = freemiumCtrl.landingSectionItemListMap;
            };

            freemiumCtrl.getSectionItemList = async function (sectionId, pageNumber, pageSize, callbackFunc) {
                var getSectionItemListObj = {
                    sectionId: sectionId,
                    pagination: PagingModel.preparePagination(pageNumber, pageSize,
                        freemiumCtrl.getDefaultDescending(sectionId), null, freemiumCtrl.getDefaultSortField(sectionId))
                };
                const response = await CatalogModel.getSectionItemList(getSectionItemListObj);
                if (callbackFunc) {
                    callbackFunc(response);
                }

            };

            freemiumCtrl.getFreeBooksSection();

            freemiumCtrl.getDefaultSortField = function (sectionId) {
                if (sectionId.indexOf('BEST_SELLERS') > -1
                    || sectionId.indexOf('NEW_YORK_TIMES_BEST_SELLERS') > -1
                    || sectionId.indexOf('EDITORS_PICKS') > -1) {
                    return 'MOST_POPULAR_THIS_WEEK';
                }
                return null;
            };

            freemiumCtrl.getDefaultDescending = function (sectionId) {
                if (sectionId.indexOf('BEST_SELLERS') > -1 || sectionId.indexOf('EDITORS_PICKS') > -1) {
                    return true;
                }
                return null;
            };


        }]);
